import BaseWidget from 'scripts/base-widget';
import {VideoDetailModel} from 'components/video-detail/video-detail-model';
import template from './swim-lane.stache';

export const SwimLane = BaseWidget.extend({
    init: function () {
        VideoDetailModel.attr('categories', this.options.categories);
        VideoDetailModel.attr('hero', this.options.hero);
        VideoDetailModel.attr('playlists', this.options.playlist);
        VideoDetailModel.attr('playlistPosition', this.options.playlistPosition);
        VideoDetailModel.initPlaylists();
        this.viewModel = VideoDetailModel;

        this.view = template;
        this._super();
    }
});
